import { StickyNote, ArrowRightLeft, Package, Wrench, FileText, User, Sparkles } from "lucide-react";

const ICON = { note: StickyNote, stage: ArrowRightLeft, products: Package, die: Wrench, quote: FileText, contact: User, created: Sparkles };

export const ActivityLog = ({ items = [] }) => (
  <section data-testid="activity-log" className="rounded-2xl bg-white border border-slate-200 p-5">
    <h2 className="text-sm font-semibold text-slate-900 mb-4">Activity</h2>
    <ol className="relative border-l border-slate-200 ml-3 space-y-5">
      {items.map((a, i) => {
        const Icon = ICON[a.kind] || Sparkles;
        return (
          <li key={a.id} data-testid={`activity-${i}`} data-kind={a.kind} className="ml-6">
            <span className="absolute -left-3.5 h-7 w-7 rounded-full bg-slate-100 border border-white flex items-center justify-center">
              <Icon className="h-3.5 w-3.5 text-slate-600" />
            </span>
            <p className="text-sm text-slate-900 whitespace-pre-wrap">{a.text}</p>
            <p className="text-xs text-slate-500 mt-0.5">
              {new Date(a.at).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })} · {a.by}
            </p>
          </li>
        );
      })}
    </ol>
  </section>
);
